import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 100 100">
    <title>Logo</title>
    <polygon
      id="Shape"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="bevel"
      strokeLinejoin="bevel"
      points="66.416966879632 96.552622898862 33.5830331203679 96.552622898862 8.43078061834695 75.447377101138 2.729227855414015 43.11226457312555 19.1461947350461 14.67724383142725 50.0 3.4473771011382 80.853805264954 14.67724383142725 97.270772144586 43.11226457312555 91.569219381653 75.447377101138"
    />
    <g id="svg_1">
        <path fill="currentColor"
        transform="translate(0.5, 6)"
        d="M 44.5,27.5 C 53.3494,27.1736 62.0161,27.507 70.5,28.5C 68.329,30.5002 65.9957,32.3335 63.5,34C 57.1406,34.1694 50.8072,34.6694 44.5,35.5C 43.3719,40.474 42.3719,45.474 41.5,50.5C 40.596,51.209 40.2627,52.209 40.5,53.5C 46.8333,53.5 53.1667,53.5 59.5,53.5C 61.334,55.5054 63.0007,57.6721 64.5,60C 55.1667,60.6667 45.8333,60.6667 36.5,60C 35,59.1667 33.8333,58 33,56.5C 33.4201,48.7262 34.7535,41.0595 37,33.5C 38.6617,30.4231 41.1617,28.4231 44.5,27.5 Z"/>
    </g>
  </svg>
);

export default IconLogo;
